import { isLocationUk } from '../../shared/utilities/isLocationUk';

export function isExUk(location) {
    return !isLocationUk(location);
}
